module.exports = __webpack_public_path__ + "img/IIS.e1dbad1.svg";